import { computed, defineComponent } from '@vue/composition-api';
import { useGetLocalizedPath } from '@/util/globalHelpers';
export default defineComponent({
    props: {
        blok: {
            type: Object,
            default: () => ({})
        }
    },
    setup(props, context) {
        const { root } = context;
        const t = (key) => root.$i18n.t(key);
        return {
            eyebrow: computed(() => props.blok?.eyebrow || t('home.q4s.vendor.eyebrow')),
            title: computed(() => props.blok?.title || t('home.q4s.vendor.title')),
            lead: computed(() => props.blok?.lead || t('home.q4s.vendor.lead')),
            useGetLocalizedPath
        };
    }
});
